export default __webpack_public_path__ + "static/media/p3.26fbd781.png";